export default {"src":"/_next/static/media/ico_checkmark_white-small.47dcfe02.svg","height":32,"width":32};